import React, { Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// Import route lists
import authRoutes from "./auth-stack/authRoutes";
import userRoutes from "./user-stack/userRoutes";
import adminRoutes from "./admin-stack/adminRoutes";
import ScrollToTop from "../utils/helpers/scroll-to-top";
import LoadingScreen from "../components/loaders/loading-screen";
import Page404 from "./404";
import Maintenance from "./maintenance";

// Lazy load NotFound component
const NotFound = React.lazy(() => import("../components/NotFound"));

function Routelist() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Suspense fallback={<LoadingScreen />}>
        <Routes>
          {authRoutes}
          {userRoutes}
          {adminRoutes}
          {/* Fallback Route */}
          <Route path="*" element={<NotFound />} />
          <Route path="404" element={<Page404 />} />
          <Route path="maintenance" element={<Maintenance />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default Routelist;
